import { getSATScheduleOptions } from '@/client/services/formInputs/satBootcamp/common'

import type { SATTestsBoundary } from '@/components/SATBootcamp/types'
import type { FormInputType } from '@/components/UI/Form/types'

export function getSATBootcampLearnerFormInputs(testsBoundary: SATTestsBoundary): FormInputType[] {
  const inputs: FormInputType[] = [
    {
      label: 'When are you planning on taking the SAT?',
      sublabel: "If you don't know, make your best guess.",
      type: 'select',
      name: 'test_schedule',
      options: getSATScheduleOptions(testsBoundary),
      required: true,
      size: 6,
    },
    {
      label: 'What is the email address of your guidance counselor at school?',
      type: 'text',
      name: 'counselor_email',
      sublabel: `Studying for the SAT is an important step in preparing to apply to college. We'll
          let your counselor know that you've taken initiative by signing up for this
          bootcamp. If you don't know your guidance counselor's email feel free to leave this blank.`,
      required: false,
      size: 6,
    },
  ]

  return inputs
}
